import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=e6635e74&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=e6635e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6635e74",
  null
  
)

export default component.exports